/**
 * Per-game configuration. Plain JSON data — each game declares its own in its
 * `main.ts` and hands it to the `MagicSlot` constructor, which registers it
 * here before any controller is built.
 */
export type GameConfig = {
    cols: number;
    rows: number;
    symbols: string[];
    /** Minimum time (ms) the reels keep spinning, even if the result arrives sooner. */
    minSpinTime: number;
    /** Delay (ms) between releasing consecutive reels to stop. */
    reelStopDelay: number;
    /** Extra time (ms) a backend-flagged reel keeps spinning with its anticipation overlay showing. */
    anticipationSpinTime: number;
    /** Below these viewport sizes (px) the game scales down to fit. */
    minHeight: number;
    minWidth: number;
    sounds: string[];
};

let gameConfig: GameConfig | null = null;

/** Registers the running game's config. Called by the `MagicSlot` constructor. */
export function setGameConfig(config: GameConfig) {
    gameConfig = config;
}

export function getGameConfig(): GameConfig {
    if (!gameConfig) {
        throw new Error('Game config is not set — pass it to the MagicSlot constructor.');
    }

    return gameConfig;
}
